import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectWithdrawalBalance: "selectWithdrawalBalance [Action]",
  selectWithdrawalBalanceLoading: "selectWithdrawalBalanceLoading [Action]",
  selectWithdrawalBalanceAsync: "selectWithdrawalBalanceAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectWithdrawalBalanceReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectWithdrawalBalance:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectWithdrawalBalanceLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectWithdrawalBalanceLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_withdrawal_balance",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectWithdrawalBalance,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectWithdrawalBalanceLoading,
      payload: false,
    });
  }
}

export function* selectWithdrawalBalance() {
  yield takeLatest(actionTypes.selectWithdrawalBalanceAsync, handleWorker);
}
